'use strict';

var ajax = require('../../utils/ajax'),
    util = require('../../utils/util'),
    progress = require('../../utils/progress');

var estimateDelivery = {
    /**
     * @function
     * @description initialize estimate events
     */
    init: function () {
        var $form = $('form[id$="_estimateddelivery"]'),
            $container = $('.estimate-delivery-result');

        $form.on('submit', function () {
            if (!$(this).valid()) {
                return false;
            }

            var url = $(this).attr('action');

            $.ajax({
                dataType: 'html',
                method: 'POST',
                url: util.ajaxUrl(url),
                data: $form.serialize(),
                beforeSend: function () {
                    progress.show($form);
                    $container.empty();
                }
            })
                .done(function (response) {
                    $container.empty().html(response);
                })
                .fail(function (xhr, textStatus) {
                    // failed
                    if (textStatus === 'parsererror') {
                        window.alert(Resources.BAD_RESPONSE);
                    }
                })
                .always(function () {
                    progress.hide();
                });

            return false;
        });
    }
};

module.exports = estimateDelivery;
